import type { TransferBatch } from '../types/uploader';

export const getTransferBatchHasLocalData = (job: TransferBatch) => {
  return typeof job?.progress !== 'undefined';
};
